/**
 * Fade-up wrapper for routed page content. No-ops to a plain div when motion
 * is disabled (reduced-motion or the animationsEnabled preference is off).
 */

import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

import { usePrefersMotion } from '@/hooks/usePrefersMotion';
import { fadeUp } from '@/lib/motion';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const animate = usePrefersMotion();
  if (!animate) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      initial="hidden"
      animate="visible"
    >
      {children}
    </motion.div>
  );
}
